import { defineMessages } from "react-intl";

const messages = defineMessages({
    notProvided: {
        id: "general.notProvidedYet",
    },
});

export default messages;
